/**
 * Fetch a page of messages for a channel. Strategy:
 *   1. If shell has a structuredCache, read from it first.
 *   2. If the cache returns < limit messages, top up from Hub (cache miss
 *      at the head of history) and write-through.
 *   3. If no cache at all, go straight to Hub.
 *
 * UI code always calls this, never the cache or hub directly.
 */
export async function getChannelMessages(ctx, workspaceId, channelId, options = {}) {
    const limit = options.limit ?? 100;
    const cache = ctx.shell.structuredCache;
    if (cache) {
        const cached = await cache.getChannelMessages(channelId, options);
        if (cached.length >= limit)
            return cached;
        const fresh = await ctx.hub.listMessages(workspaceId, channelId, options);
        await cache.upsertMessages(fresh);
        return fresh;
    }
    return ctx.hub.listMessages(workspaceId, channelId, options);
}
export async function sendMessage(ctx, workspaceId, channelId, input) {
    const message = await ctx.hub.sendMessage(workspaceId, channelId, input);
    // Write-through if we have a cache; otherwise the message will come back
    // via the live Hub stream / next refetch.
    await ctx.shell.structuredCache?.upsertMessages([message]);
    return message;
}
export async function getMessageReactions(ctx, messageId) {
    const cache = ctx.shell.structuredCache;
    if (cache) {
        const cachedReactions = await cache.getMessageReactions(messageId);
        if (cachedReactions.length > 0) {
            return groupReactions(cachedReactions);
        }
    }
    return ctx.hub.getMessageReactions(messageId);
}
function groupReactions(reactions) {
    const byEmoji = new Map();
    for (const r of reactions) {
        const authors = byEmoji.get(r.emoji) ?? new Set();
        authors.add(r.author_name);
        byEmoji.set(r.emoji, authors);
    }
    return Array.from(byEmoji.entries())
        .map(([emoji, authors]) => ({
        emoji,
        count: authors.size,
        authors: Array.from(authors),
    }))
        .sort((a, b) => b.count - a.count);
}
//# sourceMappingURL=messages.js.map